import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LoginService } from '../services/login.service';
import { PermissionService } from '../services/permission.service';
import { ToastService } from '../services/toast.service';

export const authGuard: CanActivateFn = (route, state) => {
  const loginService = inject(LoginService)
  const router = inject(Router)

  const roles = route.data['roles'] || []

  return loginService.isAutenticado() ? temPermissao(roles) : router.createUrlTree(['login'])
};

function temPermissao(roles: string[]): boolean{
  const permissionService = inject(PermissionService)
  const toast = inject(ToastService)

  var retorno = roles.some(role => permissionService.hasPermission(role))

  if(!retorno && roles.length != 0){

    toast.erro("Sem permissão", "Você não tem permissão para acessar")
    
    return false;
  }

  return true;
}